import { javantApi } from "../constants"

export const AuthorPageService = {
    getData(userName, page=1) {
        if (page === 1) {
            return javantApi.get(`user/detail/${userName}`)
        }
        return javantApi.get(`user/detail/${userName}/page/${page}`)
    }
}